class MarqueePlayerButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.player = document.getElementById(this.getAttribute('aria-controls'));
    this.playerSpeed = this.player.getAttribute('speed');
    this.playerButton = this.querySelector('button');
    this.addEventListener('click', this.togglePlayer.bind(this));
  }
  togglePlayer() {
    if (this.player.getAttribute('speed') === '0') {
      this.player.setAttribute('speed', this.playerSpeed);
      this.playerButton.querySelector('svg:first-child').classList.remove('hidden');
      this.playerButton.querySelector('svg:last-child').classList.add('hidden');
    } else {
      this.player.setAttribute('speed', '0');
      this.playerButton.querySelector('svg:first-child').classList.add('hidden');
      this.playerButton.querySelector('svg:last-child').classList.remove('hidden');
    }
  }
}

if (!customElements.get('marquee-player-button')) {
  customElements.define('marquee-player-button', MarqueePlayerButton);
}
